import React from 'react';
import { useQuiz } from '../contexts/QuizContext';
import { questions } from '../data/questions';
import QuestionCard from './QuestionCard';

const QuizContainer = () => {
  const { currentPhase, currentQuestionIndex } = useQuiz();
  
  // Encontra a fase atual
  const currentPhaseData = questions.find(phase => phase.id === currentPhase);
  
  // Encontra a pergunta atual
  const currentQuestion = currentPhaseData?.questions[currentQuestionIndex];

  return (
    <div className="quiz-container">
      {currentQuestion && (
        <QuestionCard question={currentQuestion} />
      )}
    </div>
  );
};

export default QuizContainer;
